import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import FormattedCurrency from '@checkout-s/FormattedCurrency';
import DetailsToggle from '@checkout-s/DetailsToggle'
import Product from './Product';
import AddedToCartMessage from '../../upsells/components/AddedToCartMessage';
import Modal from '../../../components/Modal';
import Translation from "../../../../shared/Translation";
import { getXssFilter } from '@showclix-shared-util/xssFilter';

class UpsellProduct extends Product {
    
    /**
     * Show product image if available or default if not
     */
    displayProductImage = () => {
        if (this.props.product.images && this.props.product.images.length >= 1) {
            let src = this.props.product.images[0];
            let alt = (this.props.product.images_alt_texts && this.props.product.images_alt_texts[0] && this.props.product.images_alt_texts[0].trim())
                ? this.props.product.images_alt_texts[0]
                : `'${this.props.product.name}' Thumbnail`;
            return (
                <div
                    className="upsell-product__image"
                    style={{ backgroundImage: `url(${src})`}}
                    role="img"
                    aria-label={alt}
                ></div>
            );
        } else {
            return (
                <div className="upsell-product__image product-image--empty">
                    <div className="upsell-product__image-icon">
                        <i className="icon-shopping_basket"></i>
                    </div>
                </div>
            );
        }
    };

    displayPrice = () => {
        const price = this.props.product.price.amount;
        const discounted = this.props.product?.discounted_price?.amount;
        if (!discounted || discounted == price) {
            return (
                <div className="upsell-product__ticket-price">
                    <FormattedCurrency>{ price }</FormattedCurrency>
                </div>
            );
        }
        return (
            <div className="upsell-product__price">
                <div className="upsell__price-match__original-price">
                    <s><span className="sr-only"><Translation>{'checkout__former_price'}</Translation></span>
                      <FormattedCurrency>{ price }</FormattedCurrency></s>
                </div>
                <div className="upsell__price-match__discounted-price">
                    <span className="sr-only"><Translation>{'checkout__discounted_price'}</Translation></span>
                    <FormattedCurrency>{ discounted }</FormattedCurrency>
                </div>
            </div>
        );
    }
    
    displayDescriptionToggle = () => {
        if (this.props.product.description || (this.props.product.images && this.props.product.images.length >= 2)) {
            return(
                <div className="upsell-product__description-toggle">
                    <DetailsToggle toggleOn={true} onClick={this.toggleDescription}/>
                </div>
            );
        }
    }
    
    renderAddedToCartMessage = () => {
        return (
            <div className="upsell-product__message">
                <AddedToCartMessage
                    countCartedItems={this.props.countCartedItems}
                    canEdit={!!this.props.canEdit}
                />
            </div>  
        );
    }

    render() {
        return <>
            <div className="upsell-product">
                {this.displayProductImage()}
                <div className="upsell-product__information">
                    <div className="upsell-product__name">
                        {this.props.product.name}
                        {(this.props.displayTypeList && +this.props.countCartedItems < 1) && 
                            this.displayDescriptionToggle()
                        }
                    </div>
                    <div className="upsell-product__information-details">
                        {+this.props.countCartedItems < 1 && 
                            this.displayPrice()
                        }
                        {!this.props.displayTypeList && 
                            this.displayDescriptionToggle()
                        }
                        {+this.props.countCartedItems < 1 && 
                            <div className="upsell-product__add-controls">
                                {this.renderAddTicketsControl({showZeroQuantity: true, disabled: !!this.props.disabled})}
                            </div>
                        }
                        {(this.props.displayTypeList && +this.props.countCartedItems > 0) && this.renderAddedToCartMessage()}
                    </div>
                </div>
                {(!this.props.displayTypeList && +this.props.countCartedItems > 0) && this.renderAddedToCartMessage()}
            </div>
            <Modal
                show={this.state.showDescription}
                size={Modal.size.large}
                onClose={this.toggleDescription}
                dismissable={true}
                forceFocus={true}
                className="modal--product-upsell-description"
                trapFocus={true}
            >
                <Modal.Header>
                    <Modal.Title><Translation>{"checkout__product"}</Translation></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="upsell-product__description">
                        {this.displayGallery()}
                        <h3 className="upsell-product-description__title">{this.props.product.name}</h3>
                        {this.displayPrice()}
                        <div
                          className="upsell-product-description__text"
                          dangerouslySetInnerHTML={{
                            __html: getXssFilter().process(this.props.product.description)
                          }}
                        />
                    </div>
                </Modal.Body>
            </Modal>
            {+this.props.countCartedItems < 1 && 
                <div className="upsell-product__configuration">
                    {this.displayProductConfiguration()}
                </div>
            }
        </>
    }
}

Product.propTypes = {
    product: PropTypes.object.isRequired,
    slug: PropTypes.string,
    productQuantity: PropTypes.number,
    productQuantities: PropTypes.arrayOf(PropTypes.number).isRequired,
    initialQuantities: PropTypes.arrayOf(PropTypes.number),
    onProductsQuantityInput: PropTypes.func.isRequired,
    onProductIncrement: PropTypes.func.isRequired,
    onProductDecrement: PropTypes.func.isRequired,
    createProductConfigurationLine : PropTypes.bool,
    displayTypeList: PropTypes.bool,
    canEdit: PropTypes.bool,
    countCartedItems: PropTypes.number,
};

export default UpsellProduct;
